import { VEHICLE_STATUS_COLORS, VEHICLE_STATUS_LABELS } from "../constants";
import type { VehicleSituation } from "../types";

export const vehicleSituationLabel = (situation: VehicleSituation) =>
	VEHICLE_STATUS_LABELS[situation];

export const vehicleSituationColor = (situation: VehicleSituation) =>
	VEHICLE_STATUS_COLORS[situation];
